import { $api } from '../y/api';
import { YLanguage, YI18NStrings } from '../y/i18n';

export interface FTranslationCommit {
    group_key: string;
    key: string;
    update: { [key in YLanguage]?: string[] };
}

export interface FTranslationGroup {
    key: string;
    parent_key?: string;
    title?: string;
    hint?: string;
    is_dictionary: boolean;
}

export interface FTranslation {
    group_key: string;
    key: string;
    hint?: string;
    size: number;
    lines: number;
    value: YI18NStrings;
}

interface FTranslationsGetResponse {
    groups: FTranslationGroup[];
    items: FTranslation[];
}

//TODOURGENT: change endpoints to f/...
export function fTranslationsGet() {
    return $api.GET<FTranslationsGetResponse>('translations');
}

export function fTranslationCreate(item: FTranslation) {
    return $api.POST<FTranslation>('translation', item);
}

export function fTranslationsUpdate(update: FTranslationCommit[]) {
    return $api.PUT<FTranslation[]>('translations', { items: update });
}
